module.exports = __webpack_public_path__ + "img/avatar7.cdb323ca.png";